<template>
	<div class="SplitLayout">
		<a-row>
			<a-col class="leftSpan" id="leftSpan" :class="{ hideMenu: !isShowMenu }">
				<a-card :bordered="false" class="contentLeft">
					<slot name="contentLeft"></slot>
				</a-card>
				<SlideBtn id-layout-menu=".ant-layout-sider" id-left-menu="#leftSpan" @emitMenu="emitMenu" @init="initMenu" />
			</a-col>
			<a-col class="rightSpan">
				<a-card :bordered="false" class="contentRight">
					<slot name="contentRight"></slot>
				</a-card>
			</a-col>
		</a-row>
	</div>
</template>
<script setup name="SplitLayout">
	let props = defineProps({
		leftSpan: {
			type: Number,
			default: () => 4
		}
	})
	let rightSpan = computed(() => {
		return 24 - props.leftSpan
	})
	let isShowMenu = ref(true)
	let initIsShowMenu = ref(true)
	let emitMenu = (val) => {
		isShowMenu.value = val
	}
	let initMenu = (val) => {
		isShowMenu.value = val
	}
</script>
<style scoped lang="less">
	.SplitLayout {
		width: 100%;
		height: 100%;
		overflow: hidden;
		.ant-row {
			height: 100%;
			width: 100%;
			overflow: hidden;
			.leftSpan,
			.rightSpan {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;
				height: 100%;
				overflow: hidden;
				& > * {
					width: 100%;
					height: 100%;
					overflow: hidden;
				}
				.contentLeft,
				.contentRight {
					background: none;
					height: 100%;
					overflow: hidden;
					& > :deep(.ant-card-body) {
						height: 100%;
						overflow: hidden;
					}
				}
				.contentRight {
					background: #fff;
				}
			}
			.leftSpan {
				flex: 0 0 258px;
				//transition: all 0.5s;
				background: #f5f8fb;
				.contentLeft {
					//transition: all 2.5s;
					//opacity: 1;
				}
				&.hideMenu {
					flex: 0 0 0px !important;
					.contentLeft {
						//transition: none;
						//opacity: 0;
					}
				}
			}
			.leftSpan {
				position: relative;
			}
		}
	}
</style>
